import { throwErrorForDev } from '@zocdoc-frontend-common/utils-react';
import {
    isProductionBuild,
    throwIfNullOrEmptyString,
    throwIfNotFunction,
} from '@zocdoc-mezzanine/internal-shared';
/**
 * Logs a warning or throws an error if one or more props are invalid.
 * This will no-op on Production builds.
 * @param {*} props - props to validate
 */
export default function handlePropValidation({ href, target, rel, onClick }) {
    if (isProductionBuild()) {
        return;
    }

    // prop validation for <button> link
    if (typeof onClick !== 'undefined') {
        throwIfNotFunction(onClick, 'onClick must be of type function');

        if (typeof href !== 'undefined') {
            throwErrorForDev('Link should only have onClick or href, not both');
        }
    } else {
        // prop validation for <a> link
        throwIfNullOrEmptyString(href, 'href must be a non-empty string');

        if (target === '_blank') {
            if (
                !rel ||
                rel.indexOf('noopener') === -1 ||
                rel.indexOf('noreferrer') === -1
            ) {
                throwErrorForDev(
                    'Links with target="_blank" must have a rel="noopener noreferrer" attribute to prevent reverse tabnabbing'
                );
            }
        }
    }
}
